import React, { useState, useEffect } from 'react';
import MultiListPopUpBothAsIndAs from '../atoms/MultiListPopUpBothAsIndAs';
function FromMoveListBothAsIndAs(props) {
  const [progress, setProgress] = useState(5);
  const [total, setTotal] = useState(10);
  const [loading, setLoadingBothAsIndAs] = useState(false);  // loader state here
  const handleClose = () => {
    props.setShowPopUpBothAsIndAs(false);
    window.location.reload();  // Refresh page on close
  };
  return (
    <div className="row form-fields">
      <div className="label col-6" >
        <label>  </label>
      </div>
      <div className="item col-6" >
        <button onClick={() => { props.setShowPopUpBothAsIndAs(true); }} className="btn btn-primary mb-2">
          Continue <span className="bi bi-gear-fill"></span>
        </button>
        {loading && (<div id="loadingOverlay">
          <div className="spinner">   </div>
          <p>Inserting {progress} of {total}...</p>
          <progress value={progress} max={total}></progress>
          <div className="spinner-text">Please don't refresh page. untill process completed </div>
        </div>)}
        <MultiListPopUpBothAsIndAs
          titleBothAsIndAs={props.labelBothAsIndAs}
          showBothAsIndAs={props.showPopUpBothAsIndAs}
          showsetterBothAsIndAs={handleClose}
          dataBothAsIndAs={props.dataBothAsIndAs}
          datasetterBothAsIndAs={props.datasetterBothAsIndAs}
          setLoadingBothAsIndAs={setLoadingBothAsIndAs}   // pass loader setter
        />
      </div>
    </div>
  )
}

export default FromMoveListBothAsIndAs